import { useEffect, useState } from 'react';

import sortResultsByStateERPI from '@core/blocks/best-match-experience/utils/sortHitsByStateERPI';
import { useFeatureFlags } from '@core/context/FeatureFlagsContext';
import { validateZip, type ValidateZipSuccess } from '@core/services/leadDelivery';
import { VoyagerResult } from '@core/ts/results';

interface ExactMatchesWithEmbeddedProps {
  exactMatches: VoyagerResult[] | null;
  recommenderMatches: VoyagerResult[] | null;
  zip: string;
}
const useExactMatchesWithEmbedded = ({ exactMatches, recommenderMatches, zip }: ExactMatchesWithEmbeddedProps) => {
  const flags = useFeatureFlags();
  const [stateAbbr, setStateAbbr] = useState<string | undefined>();

  useEffect(() => {
    (async () => {
      const { stateAbbr } = (await validateZip(zip)) as ValidateZipSuccess;
      setStateAbbr(stateAbbr);
    })();
  }, [zip]);

  const addRecommenderResults = flags.embeddedRecommenderABTest === 'test';
  const exactMatchesWithEmbeddedRecommender = sortResultsByStateERPI(
    [...(exactMatches ?? []), ...(recommenderMatches ?? [])],
    stateAbbr || ''
  );

  // @TODO: remove this when AB tests results for recommender is done
  return addRecommenderResults ? exactMatchesWithEmbeddedRecommender : exactMatches;
};

export default useExactMatchesWithEmbedded;
